import { render, staticRenderFns } from "./ReportInfoDialog.vue?vue&type=template&id=0db3b986&scoped=true"
import script from "./ReportInfoDialog.vue?vue&type=script&lang=ts"
export * from "./ReportInfoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3b986",
  null
  
)

export default component.exports